import React, { useState } from "react";
import "./forgetPass.css";
import { mainBg } from "../../assets/img/imgIndex";
import { URLS } from "../../Services/Constant";
import { post } from "../../Services/ApiHandler";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";

const ForgetPass = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email || "");
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Validate email
    if (!email) {
      setError("Email is required");
      return;
    } else if (!validateEmail(email)) {
      setError("Please enter a valid email address");
      return;
    }

    setError("");
    setLoading(true);
    console.log("Forgot Password Form Submitted:", { email });

    post(URLS.FORGOT_PASSWORD, { email: email })
      .then((res) => {
        if (res?.status === "success") {
          toast.success(
            res?.message || "Password reset link sent successfully"
          );
          setLoading(false);

          setTimeout(() => {
            navigate("/");
          }, 1500);
        } else {
          setLoading(false);
          // toast.error(res?.message || "Failed to send reset link");
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error("Forgot password error:", err);
        // toast.error(err?.message || "An error occurred");
      });
  };

  const handleChange = (e) => {
    setEmail(e.target.value || "");
    setError(""); // Clear error when user types
  };

  return (
    <div className="forgetPass-container">
      <div className="forgetPass-left">
        <img src={mainBg} alt="Cooking" className="forgetPass-left-img" />
      </div>
      <div className="forgetPass-right">
        <form className="forgetPass-form-wrapper" onSubmit={handleSubmit}>
          <h1 className="brand-name">Forgot Password</h1>

          <div className="form-group">
            <label>Email ID</label>
            <input
              type="email"
              value={email || ""}
              onChange={handleChange}
              placeholder="Enter email address"
            />
            {error && <span className="error-message">{error}</span>}
          </div>

          <button
            type="submit"
            className="forgetPass-button"
            disabled={loading}
          >
            {loading ? "Loading..." : "Submit"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ForgetPass;
